import AgendaTimeSlot from "@/domain/entities/agenda/AgendaTimeSlot";
import { AgendaTimeSlot as AgendaTimeSlotSDK } from "@cs_teamwaydev/mailvista-sdk_react";

const agendaTimeSlotMapper = (agendaTimeSlot: AgendaTimeSlotSDK) =>
    new AgendaTimeSlot({
        startDate: new Date(agendaTimeSlot.startDate),
        endDate: new Date(agendaTimeSlot.endDate),
    });

export default agendaTimeSlotMapper;
